import React from "react";

const ImageAndTextComponent = (props) => {
    const { Renderer } = props;

    return <Renderer {...props} />;
};

export default ImageAndTextComponent;
